import { AcademicCapIcon } from "@heroicons/react/solid";

const obj = {
  title:
    "STAAR English II: Informational, Argumentative, or Correspondence - Batch Marking with Word",
  desc: "Use this tool to mark free response essays to STAAR English II constructed response questions. AO1 (‘Organization and Development of Ideas’) out of 3. AO2 (‘Conventions') out of 2.",
  category: "staarengword",
  Icon: AcademicCapIcon,
  // tags: [],
  permissions: ["user"],

  fromColor: "green-400",
  toColor: "green-600",

  to: "/ai/writing/texasengtwoword",
  api: "/ai/writing/texasengtwoword",

  output: {
    title:
      "STAAR English II: Informational, Argumentative, or Correspondence - Batch Marking with Word",
    desc: "Please wait as we query AI models. This can take up to 2 minutes.",
    // Icon: RefreshIcon,
    // color: "",
  },

  prompts: [
    {
      title:
        "STAAR English II: Informational, Argumentative, or Correspondence - Batch Marking with Word",
      desc: "Enter the candidate's response",
      // n: 1,
      prompts: [
        {
          title: "Essay Title",
          attr: "essay_title",
          value: "",
          placeholder: "Enter the essay title here",
          label: "Essay Title",
          type: "textarea",
          maxLength: 950,
          required: true,
          example:
            "Read the excerpt from The Song of the Lark. Based on the information in the excerpt, write a response to the following:\n\nExplain how acquiring the loft room changes Thea.\n\nWrite a well-organized informational composition that uses specific evidence from the excerpt to support your answer.\n\nRemember to —\n\nclearly state your thesis\norganize your writing\ndevelop your ideas in detail\nuse evidence from the selection in your response\nuse correct spelling, capitalization, punctuation, and grammar\nManage your time carefully so that you can —\n\nreview the selection\nplan your response\nwrite your response\nrevise and edit your response\nWrite your response in the box provided.",
        },

        {
          title: "Extract A",
          attr: "extract1",
          value: "",
          placeholder: "Enter the extract here",
          label: "extract1",
          type: "textarea",
          maxLength: 5000,
          required: true,
          error: "",
          example:
            "Eleven-year-old Thea, an aspiring vocalist, teaches piano lessons in Moonstone, Colorado, in the late 1800s.\nfrom The Song of the Lark by Willa Cather\n\nWinter was long in coming that year. Throughout October the days were bathed in sunlight and the air was clear as crystal. The town kept its cheerful summer aspect, the desert glistened with light, the sand hills every day went through magical changes of color. The scarlet sage bloomed late in the front yards, the cottonwood leaves were bright gold long before they fell, and it was not until November that the green on\nthe tamarisks began to cloud and fade. There was a flurry of snow about Thanksgiving, and then December came on warm and clear.\n\nThea had three music pupils now, little girls whose mothers declared that Professor Wunsch was “much too severe.” They took their lessons on Saturday, and this, of course, cut down her time for play. She did not really mind this because she was allowed to use the money—her pupils paid her twenty-five cents a lesson—to fit up a little room for herself upstairs in the half-story. It was the end room of the wing, and was not plastered, but was snugly lined with soft pine. The ceiling was so low that a grown person could reach it with the palm of the hand, and it sloped down on either side. There was only one window, but it was a double one and went to the floor. In October, while the days were still warm, Thea and Tillie papered the room, walls and ceiling in the same paper, small red and brown roses on a yellowish ground. Thea bought a brown cotton carpet, and her big brother, Gus, put it down for her one Sunday. She made white cheesecloth curtains and hung them on a tape. Her mother gave her an old walnut dresser with a broken mirror, and she had her own dumpy walnut single bed, and a blue washbowl and pitcher which she had drawn at a church fair lottery. At the head of her bed she had a tall round wooden hat-crate, from the clothing store. This, standing on end and draped with cretonne, made a fairly steady table for her lantern. She was not allowed to take a lamp upstairs, so Ray Kennedy gave her a railroad lantern by which she could read at night.\n\nIn winter this loft room of Thea’s was bitterly cold, but against her mother’s advice—and Tillie’s—she always left her window open a little way. Thea asked\nDr. Archie about the window, and he told her that a girl who sang must always have plenty of fresh air, or her voice would get husky, and that the cold would harden her throat. The important thing, he said, was to keep your feet warm. On very cold nights Thea always put a brick in the oven after supper, and when she went upstairs she wrapped it in an old flannel petticoat and put it in her bed. The boys, who would never heat bricks for themselves, sometimes carried off Thea’s, and thought it a good joke to get ahead of her.\n\nWhen Thea first plunged in between her red blankets, the cold sometimes kept her awake for a good while. After half an hour or so, a warm wave crept over her body and round, sturdy legs; she glowed like a little stove with the warmth of her own blood, and the heavy quilts and red blankets grew warm wherever they touched her, though her breath sometimes froze on the coverlid. Before daylight, her internal fires went down a little, and she often wakened to find herself drawn up into a tight ball, somewhat stiff in the legs. But that made it all the easier to get up.\n\nThe acquisition of this room was the beginning of a new era in Thea’s life. It was one of the most important things that ever happened to her. Hitherto, except in summer, when she could be out of doors, she had lived in constant turmoil; the family, the day school. The clamor about her drowned the voice within herself. In the end of the wing, separated from the other upstairs sleeping-rooms by a long, cold, unfinished lumber room, her mind worked better. She thought things out more clearly. Pleasant plans and ideas occurred to her which had never come before. She had certain thoughts which were like companions, ideas which were like older and wiser friends. She left them there in the morning, when she finished dressing in the cold, and at night, when she came up with her lantern and shut the door after a busy day, she found them awaiting her.\n\nFrom the time when she moved up into the wing, Thea began to live a double life. During the day, when the hours were full of tasks, she was one of the Kronborg children, but at night she was a different person. On Friday and Saturday nights she always read for a long while after she was in bed. She had no clock, and there was no one to nag her.\n\nFrom THE SONG OF THE LARK by Willa Sibert Cather—Public Domain",
        },

        {
          title: "Extract B",
          attr: "extract2",
          value: "",
          placeholder: "Enter the extract here",
          label: "extract2",
          type: "textarea",
          maxLength: 5000,
          required: true,
          error: "",
          example: ".",
        },

        {
          title: "Essay 1 (Upload .docx or .doc).",
          attr: "word_file1",
          value: "",
          label: "Upload your Word file",
          type: "file",
          required: true,
          error: "",
        },

        {
          title: "Essay 2 (Upload .docx or .doc).",
          attr: "word_file2",
          value: "",
          label: "Upload your Word file",
          type: "file",
          required: true,
          error: "",
        },

        {
          title: "Essay 3 (Upload .docx or .doc).",
          attr: "word_file3",
          value: "",
          label: "Upload your Word file",
          type: "file",
          required: false,
          error: "",
        },

        {
          title: "Essay 4 (Upload .docx or .doc).",
          attr: "word_file4",
          value: "",
          label: "Upload your Word file",
          type: "file",
          required: false,
          error: "",
        },

        {
          title: "Essay 5 (Upload .docx or .doc).",
          attr: "word_file5",
          value: "",
          label: "Upload your Word file",
          type: "file",
          required: false,
          error: "",
        },

        {
          title: "Essay 6 (Upload .docx or .doc).",
          attr: "word_file6",
          value: "",
          label: "Upload your Word file",
          type: "file",
          required: false,
          error: "",
        },

        {
          title: "Essay 7 (Upload .docx or .doc).",
          attr: "word_file7",
          value: "",
          label: "Upload your Word file",
          type: "file",
          required: false,
          error: "",
        },

        {
          title: "Essay 8 (Upload .docx or .doc).",
          attr: "word_file8",
          value: "",
          label: "Upload your Word file",
          type: "file",
          required: false,
          error: "",
        },

        {
          title: "Essay 9 (Upload .docx or .doc).",
          attr: "word_file9",
          value: "",
          label: "Upload your Word file",
          type: "file",
          required: false,
          error: "",
        },

        {
          title: "Essay 10 (Upload .docx or .doc).",
          attr: "word_file10",
          value: "",
          label: "Upload your Word file",
          type: "file",
          required: false,
          error: "",
        },
      ],
      example: {
        output: "", // outputs: [],
        // Icon: RefreshIcon,
        // color: "",
      },
    },
  ],
};

export default obj;
